import { Diagnostic, Rule } from "@siteimprove/alfa-act";
import { Err, Ok } from "@siteimprove/alfa-result";
import { Technique } from "@siteimprove/alfa-wcag";
import { video } from "../common/applicability/video.js";
import { expectation } from "../common/act/expectation.js";
import { Question } from "../common/act/question.js";
import { Scope, Stability } from "../tags/index.js";
export default Rule.Atomic.of({
    uri: "https://alfa.siteimprove.com/rules/sia-r22",
    requirements: [Technique.of("G87"), Technique.of("G93"), Technique.of("H95")],
    tags: [Scope.Component, Stability.Stable],
    evaluate({ device, document }) {
        return {
            applicability() {
                return video(document, device, { audio: { has: true } });
            },
            expectations(target) {
                return {
                    1: Question.of("has-captions", target).map((hasCaptions) => expectation(hasCaptions, () => Outcomes.HasCaptions, () => Outcomes.HasNoCaptions)),
                };
            },
        };
    },
});
/**
 * @public
 */
export var Outcomes;
(function (Outcomes) {
    Outcomes.HasCaptions = Ok.of(Diagnostic.of(`The \`<video>\` element has captions`));
    Outcomes.HasNoCaptions = Err.of(Diagnostic.of(`The \`<video>\` element does not have captions`));
})(Outcomes || (Outcomes = {}));
//# sourceMappingURL=rule.js.map